<template>
  <div class="x-misscenlist-box" style="margin:15px">
    <el-table :data="misslist" style="width: 100%" ref="multipleTable" border>
      <el-table-column label="任务ID" width="">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.id }}</span>
        </template>
      </el-table-column>

      <el-table-column label="任务标题" width="">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.title }}</span>
        </template>
      </el-table-column>

      <el-table-column label="参与员工数" width="">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.user_count }}</span>
        </template>
      </el-table-column>

      <el-table-column label="实际完成人数" width="">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.pass_count }}</span>
        </template>
      </el-table-column>

      <el-table-column label="通过率" width="">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.rate }}%</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="prev, pager, next"
      :total="alllength"
      background
      :hide-on-single-page="onlyone"
       @next-click="nextpage"
       @current-change="changepage"
       :page-size="everypage"
       :page-sizes="[1,1,1,1]">
    </el-pagination>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'datacenter1',
  data () {
    return {
      thpage:1,
      misslist:[],
      everypage:20,//????????????????
      onlyone:false,//!!!!!!!!!!!!!!!
      alllength:0

    }
  },
  created() {

  },
  mounted(){
    this.getdata()
  },
  methods:{
    getdata:function(num){
      console.log("当前页数："+num);
      if(num){
        this.thpage=num;
      }else{
        this.thpage=1;
      }
      axios.get('/admin/spc/taskList', {
        params: {
          sec: localStorage.token,
          page:this.thpage
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.misslist = response.data.data.list;//部门列表数据
            this.alllength = response.data.data.count;
            this.everypage = response.data.data.limit;
            console.log('总数：'+response.data.data.count);
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    nextpage:function(num){
      console.log(num);
      this.getdata(num)
    },
    changepage:function(num){
      console.log(num);
      this.getdata(num)
    },
  }
}
</script>

<style>
  .x-miss-tabbox .el-tabs__item{
    font-size: 16px;
  }.x-miss-tabbox .el-tabs__nav-wrap::after{
    height: 0;
  }.x-miss-tabbox .el-tabs__nav-wrap{
    margin-left: 10px;
  }.x-pagination{
    margin-top: 20px;
  }.x-misscenlist-box .el-table th.is-leaf{
    text-align: center;
  }.x-misscenlist-box .el-table thead tr th{
    background-color: #F2F2F2;
  }.x-misscenlist-box .el-table td{
    text-align: center;
  }.x-misscenlist-box .el-tabs__nav-wrap::after{
    height: 0;
  }.x-text-see{
    color: #BDA17A;
    text-decoration: none;

  }.x-ac-remove {
      background: url(../images/change.png)no-repeat;
      background-size: contain;
      width: 14px;
      height: 14px;
      vertical-align: bottom;
      padding-left: 25px;
      margin-right: 20px;
  }.x-ac-remove {
    background: url(../images/remove.png)no-repeat;
    background-size: contain;
    color: #FF4D4D;
    cursor: pointer;
  }.x-miss-addbox{
    text-align: left;
    margin-bottom: 15px;
  }.el-form-item__content{
    text-align: left;
  }.x-all-btn {
      margin: 30px 0;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: space-between;
  }.x-btn {
      background-color: #BDA17A;
      font-size: 14px;
      color: #fff;
      text-align: center;
      height: 44px;
      line-height: 44px;
      width: 126px;
      border-radius: 5px;
      cursor: pointer;
      display: inline-block;
      margin-right: 20px;
      z-index: 0;
  }.x-btn-right {
      display: flex;
      align-items: center;
      justify-content: space-between;
  }.x-btn-right .x-search-input{
    width: auto;
    margin-right: 10px;
    /* float: left; */
  }.x-miss-li{
    color: #333;
    cursor: pointer;
  }.x-bianji{
    /* background: url(../images/change.png)no-repeat; */
    background-size: contain;
    width: 14px;
    height: 14px;
    vertical-align: bottom;
    padding-left: 25px;
    margin-right: 20px;
    display: initial;
    color: #BDA17A;
    cursor: pointer;
  }.x-person-right{
    background-color: #fff;
    padding: 0 10px;
  }.x-addclass-box{
    padding: 10px;
  }.x-tree-title{
    background-color: #BDA17A;
    color: #fff;
    text-align: center;
    padding: 10px 5px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    display: block;
  }.x-person-left{
    background-color: #fff;
    height: 800px;
  }.x-tree-title span{
    cursor: pointer;
    border: 1px solid #fff;
    border-radius: 5px;
    padding: 2px;
    width: 80px;
    margin: auto;
    display: block;
    margin-top: 6px;
  }.el-pagination{
    margin-top: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/datacenter2.vue